import { render, staticRenderFns } from "./ReClientChatNest.vue?vue&type=template&id=2876a394&scoped=true"
import script from "./ReClientChatNest.vue?vue&type=script&lang=js"
export * from "./ReClientChatNest.vue?vue&type=script&lang=js"
import style0 from "./ReClientChatNest.vue?vue&type=style&index=0&id=2876a394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2876a394",
  null
  
)

export default component.exports